import CELL_DATA_TYPES from '../cell-types.config';

export const COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    width: '30%',
    align: 'left',
    dataKey: 'title',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'dateStart',
    label: 'Date enabled',
    width: '5%',
    align: 'center',
    dataKey: 'dateStart',
    sortable: false,
    type: CELL_DATA_TYPES.DATE,
  },
  {
    id: 'dateEnd',
    label: 'Date disabled',
    width: '5%',
    align: 'center',
    dataKey: 'dateEnd',
    sortable: false,
    type: CELL_DATA_TYPES.DATE,
  },
  {
    id: 'dateStartFeatured',
    label: 'Featured enabled',
    width: '5%',
    align: 'center',
    dataKey: 'dateStartFeatured',
    sortable: false,
    type: CELL_DATA_TYPES.DATE,
  },
  {
    id: 'dateEndFeatured',
    label: 'Featured disabled',
    width: '5%',
    align: 'center',
    dataKey: 'dateEndFeatured',
    sortable: false,
    type: CELL_DATA_TYPES.DATE,
  },
];

export default COLUMNS;
